import { Render3dStore } from "./Render3dStore";
import { firestore, storage } from "common/Firebase";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { LibraryStore } from "modules/library/LibraryStore";
import { WBSStore } from "modules/WBS/WBSStore";
import { Development } from "modules/development/models/Development";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import * as _ from "lodash";
import { formatNumber } from "utils/MathUtils";

class Service {
  async mountRender3D() {
    Render3dStore.modelStyles = [];

    Render3dStore.libraries = [];

    // PRUBK-423 - Definição de array de Promises para controlar o estado de inicialização do viewer
    const setWexbimPromises = [] as any;
    const setNavigationPromises = [] as any;
    Render3dStore.viewerLoadCounter = 0;
    for (let wexbim of LibraryStore.libraries) {
      if (WBSStore.WBS.id !== "" && wexbim.data.enabled) {
        // PRUBK-423 - Controle de carregamento de IFCs federados no primeiro load do viewer
        //if (!Render3dStore.viewerStarted)
        Render3dStore.viewerLoadCounter++;
        if (!Render3dStore.loadingViewer) Render3dStore.loadingViewer = true;

        setWexbimPromises.push(
          Render3dService.setWexbimStorage(wexbim.data.name, wexbim.id)
        );
        setNavigationPromises.push(
          Render3dService.fetchFileNavigation(wexbim.id)
        );
        Render3dStore.libraries.push(
          Object.assign(
            {},
            { ...wexbim.data, storage: false, checked: true, id: wexbim.id }
          ) as never
        );
      }
    }

    Promise.all(setNavigationPromises).then(() => {
      Render3dStore.navigationLoaded = true;
    });
  }

  async viewerRemoveIFC(lib) {
    if (
      Render3dStore.libraries &&
      Render3dStore.libraries.find((m: any, index) => {
        return m.id == lib.id;
      })
    ) {
      await Render3dStore.resetView(false);
      var modelId = Render3dStore.modelIdCollection.find((m: any, index) => {
        var mId = m.tag.toLowerCase() === lib.id.toLowerCase();
        return mId;
      }) as any;
      if (modelId) {
        let dev = DevelopmentStore.developmentSelected;
        let myModel = Render3dStore.xeokitViewer.scene.models[modelId.model];
        // Destroy the model
        if (!myModel) {
          console.error("Model not loaded: " + modelId);
          return;
        }
        myModel.destroy();
      }
      Render3dStore.libraries.splice(
        Render3dStore.libraries.findIndex((item: any) => item.id === lib.id),
        1
      );

      // Se excluir o modelo ou desativar no 3d, salva a tag do modelo ao invés de usar o numero
      // Já que quando ele for adicionado novamente vai receber um novo número.
      let itemsView: any = [...Render3dStore.itemsView];
      for (let i = 0; i < itemsView.length; i++) {
        if (modelId.model == itemsView[i].modelId) {
          //PRUBK-754
          itemsView[i].modelId = modelId.tag;
        }
      }
      Render3dStore.itemsView = itemsView;
      Render3dStore.modelIdCollection.splice(
        Render3dStore.modelIdCollection.findIndex((m: any) => {
          return m.tag.toLowerCase() === lib.id.toLowerCase();
        }),
        1
      );
    }
  }

  async setWexbimStorage(name, id): Promise<void> {
    var cleanName = name.split(".");
    cleanName.pop();
    cleanName = cleanName.join(".");

    var db;
    // Abre o banco de dados
    var request = await indexedDB.open("3dmodels");

    // Cria a estrutura do banco
    request.onupgradeneeded = function (event) {
      let target: any = event.target;
      db = target.result;
      db.createObjectStore("models");
    };

    request.onerror = (event) => {
      this.loadingModel(id, cleanName, db);
      return;
    };

    request.onsuccess = async (event) => {
      if (request.result === undefined) {
        this.loadingModel(id, cleanName, db);
        return;
      }
      const dev = DevelopmentStore.developmentSelected;
      let target: any = event.target;
      db = target.result;
      var store = db.transaction(["models"], "readwrite").objectStore("models");
      request = await store.get(`xkt_${cleanName}`);

      request.onerror = (event) => {
        this.loadingModel(id, cleanName, db);
        return;
      };
      request.onsuccess = (event) => {
        if (request.result === undefined) {
          this.loadingModel(id, cleanName, db);
          return;
        } else {
          // Se achou com sucesso no cache do navegador, carrega a partir dele e não faz o download
          let dev = DevelopmentStore.developmentSelected;
          Render3dStore.loadXeokit({ key: id, result: request.result });
          return;
        }
      };
    };
  }

  async removeWexbimStorage(
    dev: FirebaseDocument<Development>,
    libraryName: string
  ) {
    // Abre conexão com o banco
    const request = await indexedDB.open("3dmodels");
    request.onsuccess = function (event) {
      let target: any = event.target;
      if (target == null || target.result == undefined) {
        return;
      }

      let db = target.result;
      var store = db.transaction(["models"], "readwrite").objectStore("models");

      // Deleta o modelo
      libraryName = libraryName.substring(0, libraryName.indexOf("."));
      store.delete(
        dev.data.isXeokitViewer ? `xkt_${libraryName}` : `wexbim_${libraryName}`
      );
    };
  }

  loadingModel(id, cleanName, db) {
    // Faz o download no arquivo caso não esteja no banco de dados
    const dev = DevelopmentStore.developmentSelected;
    let down: any = undefined;
    down = storage.ref().child(`xkt/${cleanName}.ifc.xkt`);
    down.getDownloadURL().then(async (url) => {
      Render3dStore.loadXeokit({ key: id, result: url });
      var xhr = new XMLHttpRequest(),
        fileReader = new FileReader();
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.addEventListener(
        "load",
        () => {
          if (xhr.status === 200) {
            fileReader.onload = (evt) => {
              var result = (evt as any).target.result,
                key = `xkt_${cleanName}`;
              var store = db
                .transaction(["models"], "readwrite")
                .objectStore("models");
              // Obtain DataURL string
              var req = store.put(result, `xkt_${cleanName}`);
              req.onerror = function (e) {
                console.log(e);
              };
              fileReader.readAsDataURL(xhr.response);
            };
          }
        },
        false
      );
      xhr.send();
    });
  }

  async fetchFileNavigation(id: any): Promise<void> {
    try {
      const items = await firestore
        .collection("developments")
        .doc(DevelopmentStore.developmentSelected.id)
        .collection("fileNavigation")
        .where("file.id", "==", id)
        .get();

      for (let doc of items.docs) {
        let data: any = doc.data();
        var keys = Object.values(data.navigation);

        for (const nav of keys.sort()) {
          const ind = Render3dStore.typesNavigation.findIndex(
            (n) => n.type === nav
          );
          if (ind < 0) {
            Render3dStore.typesNavigation.push({
              type: nav,
              file: [id],
              items: Array<object>(),
            });
          } else {
            const indFile = Render3dStore.typesNavigation[ind].file.indexOf(id);
            if (indFile < 0) {
              Render3dStore.typesNavigation[ind].file.push(id);
            }
          }
        }
      }
      await this.fetchFileNavigationItem(id);
    } catch (e) {}
  }

  /**
   * Método assíncrono responsável por recuperar e formatar as propriedades do elemento do modelo 3D para exibir no painel de propriedades
   */
  async getItemPropsArray(text, isByType): Promise<void> {
    Render3dStore.propertyRendered = [];
    // Recupera as informações do elemento selecionado no Firebase
    const allLabels: any = [];
    const labelsDev = await firestore
      .collection("developments")
      .doc(DevelopmentStore.developmentSelected.id)
      .collection("fileItems")
      .where(isByType ? "type" : "objectType", "==", text)
      .get();

    allLabels.push(...labelsDev.docs);

    let allPropsList = new Array();
    for (let i = 0; i < allLabels.length; i++) {
      // Atribui o conteúdo do documento do firebase em uma variável para reutilização
      const docData = allLabels[i].data();
      // Define a variável props com o conteúdo das propriedades agrupadas no firebase
      let props = docData.propertiesByGroup;
      // e inclui um novo grupo para identificar os materiais do elemento selecionado
      props["Materials"] = docData.materials;

      Render3dStore.fileName = docData.name;

      for (let [key, content] of Object.entries(props)) {
        if (
          key.toString().toLowerCase() !== "quantities" &&
          key.toString().toLowerCase() !== "dimensions" &&
          key.toString().toLowerCase() !== "cotas" &&
          key.toString().toLowerCase() !== "identification"
        ) {
          continue;
        }

        let item = { title: key, props: new Array() };
        let unitWParent = "";
        for (let [title, { value, unit }] of Object.entries(
          content as any
        ) as any) {
          unitWParent = unit ? `(${unit})` : "";
          if (
            title === "Type" &&
            key.toString().toLowerCase() === "identification"
          ) {
            item.props.push({
              title: title + " " + unitWParent,
              value: value,
            });
          } else {
            item.props.push({ title: title + " " + unitWParent, value });
          }
        }
        if (i === 0) {
          allPropsList.push(item);
        } else {
          for (let lpIdx = 0; lpIdx < allPropsList.length; lpIdx++) {
            const allProps = allPropsList[lpIdx];
            if (allProps.title === item.title) {
              for (let ipIdx = 0; ipIdx < item.props.length; ipIdx++) {
                const itemProperties = item.props[ipIdx];
                let found = false;
                for (
                  let lppIdx = allProps.props.length - 1;
                  lppIdx >= 0;
                  lppIdx--
                ) {
                  const properties = allProps.props[lppIdx];
                  if (properties.title === itemProperties.title) {
                    found = true;
                    if (
                      allProps.title.toString().toLowerCase() !==
                      "identification"
                    ) {
                      properties.value =
                        properties.value * 1 + itemProperties.value * 1;
                    } else {
                      // Identificação só fica se todos forem iguais
                      if (properties.value !== itemProperties.value) {
                        allProps.props.splice(lppIdx, 1);
                      }
                    }
                    break;
                  }
                }
                // Se ainda não estava na lista, adiciona o campo
                if (!found) {
                  allProps.props.push({
                    title: itemProperties.title,
                    value: itemProperties.value,
                  });
                }
              }
            }
          }
        }
      }
    }

    Render3dStore.propertyRendered = this.orderProperties(allPropsList);
  }

  /**
   * Método assíncrono responsável por recuperar e formatar as propriedades do elemento do modelo 3D para exibir no painel de propriedades
   */
  async getItemProps(label: any, GUID: any, modelId: any): Promise<void> {
    let dev = DevelopmentStore.developmentSelected;
    let labelToSearch = "GUID";
    let valueToSearch = GUID;

    // Recupera as informações do elemento selecionado no Firebase
    const labelsDev = await firestore
      .collection("developments")
      .doc(dev.id)
      .collection("fileItems")
      .where(labelToSearch, "==", valueToSearch)
      .get();

    if (labelsDev.docs[0] == undefined) {
      Render3dStore.fileName = "";
      return;
    }
    // Atribui o conteúdo do documento do firebase em uma variável para reutilização
    let docDataArray = labelsDev.docs;
    let docData: any = undefined;
    if (docDataArray.length > 0) {
      for (let i = 0; i < docDataArray.length; i++) {
        let tmp = docDataArray[i].data();
        let tmpModelId = Render3dStore.getModelId(tmp.file.id);
        if (tmpModelId == modelId) {
          docData = tmp;
        }
      }
    } else {
      docData = labelsDev.docs[0].data();
    }

    let labelProps = new Array();

    // Define a variável props com o conteúdo das propriedades agrupadas no firebase
    if (docData) {
      let props = docData.propertiesByGroup;
      // e inclui um novo grupo para identificar os materiais do elemento selecionado
      props["Materials"] = docData.materials;
      Render3dStore.fileName = docData.name;

      for (let [key, content] of Object.entries(props)) {
        let item = { title: key, props: new Array() };
        for (let [title, { value, unit }] of Object.entries(
          content as any
        ) as any) {
          var unitWParent = unit ? `(${unit})` : "";

          if (key.toString().toLowerCase() === "quantities") {
            var valueFormated = formatNumber(value);
            item.props.push({
              title: title + " " + unitWParent,
              value: valueFormated,
            });
          } else {
            if (
              title === "Type" &&
              key.toString().toLowerCase() === "identification"
            ) {
              item.props.push({
                title: title + " " + unitWParent,
                value: value,
              });
            } else {
              item.props.push({ title: title + " " + unitWParent, value });
            }
          }
        }
        labelProps.push(item);
      }
    }
    Render3dStore.propertyRendered = this.orderProperties(labelProps);
  }

  /*
    Ordena a lista de propriedades de acordo com a lista definida na issue PRUBK-678:
    - Identification
    - Classification
    - Location
    - Quantities
    - Cotas
    - Demais em ordem alfabética
  */
  orderProperties(labelProps) {
    let newLabelProps: any = [];
    // Ordena as propriedades em ordem alfabética
    labelProps.sort(function (a, b) {
      if (a.title < b.title) {
        return -1;
      }
      if (a.title > b.title) {
        return 1;
      }
      return 0;
    });

    // Ordena os itens das propriedades em ordem alfabética
    for (let i = 0; i < labelProps.length; i++) {
      const element = labelProps[i];
      element.props.sort(function (a, b) {
        if (a.title < b.title) {
          return -1;
        }
        if (a.title > b.title) {
          return 1;
        }
        return 0;
      });
    }

    // Adiciona em primeiro os itens definidos, e guarda os ids para não adicionar novamente
    let arrayId: any = [];
    let arrayProps = [
      "identification",
      "classification",
      "location",
      "quantities",
      "cotas",
    ];
    for (let idx = 0; idx < arrayProps.length; idx++) {
      let id = labelProps.findIndex(
        (i) => i.title.toLowerCase() == arrayProps[idx]
      );
      if (id >= 0) {
        newLabelProps.push(labelProps[id]);
        arrayId.push(id);
      }
    }

    // Adiciona os itens que não são padrão
    for (let i = 0; i < labelProps.length; i++) {
      if (arrayId.findIndex((id) => id == i) == -1) {
        newLabelProps.push(labelProps[i]);
      }
    }
    return newLabelProps;
  }

  /**
   * Função responsavel por carregar os dados da variavel "itemsView".
    Essa função é chamada sempre que essa variavel for ser utilizada.
    Ela sempre carrega os modelos que estão visíveis no 3D 1 vez, se ele já foi carregado, não faz nada.
    @method fetchFileItemsIfcRef
    @category Viewer3D
   * @return {Promise<void>}
   */
  async fetchFileItemsIfcRef(): Promise<void> {
    const fileItemsIfcRef = firestore
      .collection("developments")
      .doc(DevelopmentStore.developmentSelected.id)
      .collection("fileItemsIfcRef");

    let idArray: any = [];
    let itemsViewTotal: any = Render3dStore.itemsView;

    // Roda por todos os modelos IFC do projeto
    for (let wexbim of LibraryStore.libraries) {
      // Filtra apenas os modelos que estão visíveis no 3D
      // E só os que ainda não foram carregados anteriormente
      if (
        WBSStore.WBS.id !== "" &&
        wexbim.data.enabled &&
        Render3dStore.ifcRefIdsLoaded.indexOf(wexbim.id) == -1
      ) {
        // Adiciona na lista dos IFC já carregados, para na proxima execução ignora-lo.
        Render3dStore.ifcRefIdsLoaded.push(wexbim.id);
        let id = wexbim.id;
        idArray.push(id);
      }
    }

    let size = 10;
    // Cria um batch de 10 elementos para não aparecer o erro "filters support a maximum of 10 elements"
    for (var i = 0; i < idArray.length; i += size) {
      // Efetua a query pelos ids do laço de repetição
      const snapshotCat = await fileItemsIfcRef
        .where("file.id", "in", idArray.slice(i, i + size))
        .get();
      for (let doc of snapshotCat.docs) {
        let data: any = doc.data();
        let modelId = Render3dStore.getModelId(data.file.id);
        itemsViewTotal.push({
          name: data.name,
          ifcLabel: data.ifcLabel,
          GUID: data.GUID,
          subType: data.subType,
          modelId: modelId,
          type: data.type,
        });
      }
    }
    if (idArray.length > 0) {
      Render3dStore.itemsView = itemsViewTotal;
    }
  }

  async changeVisibilityByType(itemsViewSelected, visibility) {
    try {
      const items = await firestore
        .collection("developments")
        .doc(DevelopmentStore.developmentSelected.id)
        .get();

      if (items.exists) {
        let data = items.data();
        let nav;

        if (data) {
          nav = data.visibility3dNavigator;
          if (nav == undefined) {
            await firestore
              .collection("developments")
              .doc(DevelopmentStore.developmentSelected.id)
              .update({
                visibility3dNavigator: [itemsViewSelected],
              });
          } else {
            if (!visibility) {
              await firestore
                .collection("developments")
                .doc(DevelopmentStore.developmentSelected.id)
                .update({
                  visibility3dNavigator: [...nav, itemsViewSelected],
                });
            }

            if (visibility) {
              let newNav = nav.filter((item) => item !== itemsViewSelected);
              await firestore
                .collection("developments")
                .doc(DevelopmentStore.developmentSelected.id)
                .update({
                  visibility3dNavigator: newNav,
                });
            }
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  async fetchFileNavigationItem(id: any): Promise<void> {
    try {
      const items = await firestore
        .collection("developments")
        .doc(DevelopmentStore.developmentSelected.id)
        .collection("fileComponentsHierarchy")
        .where("file.id", "==", id)
        .get();

      let typesNavigationTmp = [...Render3dStore.typesNavigation];

      for (let doc of items.docs) {
        let data: any = doc.data();
        var keys = Object.keys(data.ifcTypes);

        /* Percorre as informações armazenadas em client para montar a estrutura de items do ifc necessária para as
         * operações da barra de ferramentas do 3D.
         * Este laço for foi mantido para compatibilidade de exibição de modelos que não possuem a coleção fileItemsIfcRef */
        for (const nav of keys.sort()) {
          const ind = typesNavigationTmp.findIndex((n) => n.type === nav);
          const indFile = typesNavigationTmp[ind].file.indexOf(id);

          if (ind < 0 || indFile < 0) {
            throw new Error(
              `IFCType ${nav} inconsistente. A importação do IFC pode estar com problemas.`
            );
          } else {
            var objType = Object.keys(data.ifcTypes[nav]);
            for (let obj of objType.sort()) {
              let itemObj = typesNavigationTmp[ind].items[obj];
              if (itemObj == undefined) {
                itemObj = { id: [id], items: [] };
              } else {
                let typesIndex = itemObj.id.findIndex((i) => i == id);
                if (typesIndex == -1) {
                  itemObj.id.push(id);
                }
              }
              typesNavigationTmp[ind].items[obj] = itemObj;
            }
          }
        }
      }
      Render3dStore.typesNavigation = typesNavigationTmp;
    } catch (e) {}
  }

  async setTypesInvisible(ifcTypes) {
    let docRef = await firestore
      .collection("developments")
      .doc(DevelopmentStore.developmentSelected.id)
      .collection("invisibleElementsIFC");

    docRef.doc("invisibleElements").set({ ifcTypes });
  }

  async fetchVisibilityElement3D() {
    try {
      let data = await firestore
        .collection("developments")
        .doc(DevelopmentStore.developmentSelected.id)
        .get();
      if (data.exists) {
        let dataFetch = data.data();
        if (dataFetch) {
          if (dataFetch.visibility3dNavigator) {
            return dataFetch.visibility3dNavigator;
          } else {
            return [];
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  async getTypesInvisible() {
    let docRef = await firestore
      .collection("developments")
      .doc(DevelopmentStore.developmentSelected.id)
      .collection("invisibleElementsIFC")
      .doc("invisibleElements")
      .get();

    let data = docRef.data();
    if (data) {
      let array = Object.values(data);
      return array[0] || [];
    }

    return [];
  }
}

let Render3dService = new Service();

export { Render3dService };



// WEBPACK FOOTER //
// ./src/modules/render3D/Render3dService.ts